import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import et from './locales/et.json';
import ru from './locales/ru.json';

export const languages = [
  { code: 'en', name: 'English' },
  { code: 'et', name: 'Eesti' },
  { code: 'ru', name: 'Русский' }
] as const;

export type LanguageCode = typeof languages[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      et: { translation: et },
      ru: { translation: ru }
    },
    fallbackLng: 'et',
    supportedLngs: ['en', 'et', 'ru'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      // No `navigator` here — first-time visitors should see Estonian
      // regardless of browser language. Once they pick a language via the
      // switcher, it persists in localStorage.
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'kyt-language'
    }
  });

// Keep <html lang> in sync with the active language (index.html hardcodes
// lang="en"; legal pages and screen readers need the real one).
const syncHtmlLang = (lng: string) => {
  document.documentElement.lang = lng;
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;

